import React from 'react';
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SectionFive = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const testimonials = [
    {
      quote:
        "“Switching to GoKwik Checkout was one of the smartest decisions. The seamless checkout has made a huge difference — no more cart abandonment from clunky flows. Our conversion rate improved by 29%, with customers returning more often.”",
      name: "Vinit Goswami, VP Technology",
      image: '/assets/images/kwikwoocomm/daisy.png',
      percent: "29%",
    },
    {
      quote:
        "GoKwik Checkout has really made a difference for us - conversions jumped from 20% to 25%. The checkout feels seamless, and the support team has been fantastic—super responsive and always ready to help.",
      name: "Sagar Sangani & Mitali Somaiya, Founders",
      image: '/assets/images/kwikwoocomm/knitrootlogo.png',
      percent: "25%",
    },
  ];

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  return (
    <div
      className="secfive-wrapper secfive-wrapper-mob position-relative overflow-hidden"
      style={{ minHeight: isMobile ? "66vh" : "62vh" }}
    >
      <Slider {...settings}>
        {testimonials.map((t, index) => (
          <div key={index} className="secfive-container" style={{ color: "black", zIndex: 1 }}>
            <div className={`secfive-content ${isMobile ? "secfive-content-mob" : ""}`}>
              <div className="secfive-left">
                <p className={`secfive-quote ${isMobile ? "secfive-quote-mob" : ""}`}>
                  {t.quote}
                </p>
                <div className="secfive-founder-info">
                  <p className="secfive-founder-name">{t.name}</p>
                  <img src={t.image} alt={t.name} className="secfive-logo" />
                </div>
              </div>
              <div className={isMobile ? "secfive-top-mob" : "secfive-right"}>
                <h1 className={isMobile ? "secfive-percent-mob" : "secfive-percent"}>
                  {t.percent}
                </h1>
                <p className={isMobile ? "secfive-label-mob" : "secfive-label"}>
                  Conversions
                </p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SectionFive;
